import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.closeOnEscape, true)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape, true)
  }

  close() {
    const frame = document.getElementById("auth_modal")
    if (frame) frame.innerHTML = ""
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return

    event.preventDefault()
    event.stopImmediatePropagation()
    this.close()
  }
}
